import { LoginState } from "../auth/LoginState";

const IF = require( "infrontjs" );

import template from './PaInfoTemplate.html';

import { Video } from "../../model/Video";
import './../../components/general/main-menu';
import './../../components/general/header-bar';
import { IndexState } from "./IndexState";
import { PaymentWallState } from "./PaymentWallState";

export class PaInfoState extends IF.State
{
    static ROUTE = '/pa-info';
    static ID = 'pa-info';

    canEnter()
    {
        if ( this.app.currentUser && false === this.app.currentUser.isPaying() && true === this.app.isNativeMobile() )
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    getRedirectUrl()
    {
        if ( null === this.app.currentUser )
        {
            return LoginState.ROUTE;
        }
        else
        {
            if ( false === this.app.currentUser.isPaying() && false === this.app.isNativeMobile() )
            {
                return PaymentWallState.ROUTE;
            }
            else
            {
                return IndexState.ROUTE;
            }
        }
    }

    async enter()
    {

        this.app.container.innerHTML = this.app.view.getHtml(
            template
        );
    }

    async exit()
    {
    }
};
